import { PROFILE_STYLE } from "../../siteInfo/SiteStyle";
const profileStyles = {
  profileCard: {
    position: "relative",
    width: "90%",
    maxWidth: 375,
    marginRight: "auto",
    marginLeft: "auto",
    marginBottom: 18,
    textAlign: "center",
    overflow: "hidden",
    borderRadius: 3,
    cursor: "pointer",
    transition: "all .5s ease",
    boxShadow: "0px 0px 9px 0px rgba(0,0,0,0.6)",
    "&:hover": {
      boxShadow: "0 9px 9px 0px rgba(0, 0, 0, 0.6)",
      transform: "scale(1.03, 1.03)",
    },
  },
  link: {
    color: "#333333",
    textDecoration: "none",
  },
  profileBackImg: {
    position: "absolute",
    width: "100%",
    height: "100%",
    overflow: "auto",
    display: "block",
  },
  coverProfileBackImg: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
  },
  profileImg: {
    width: 150,
    height: 150,
    marginTop: 30,
    marginRight: "auto",
    marginLeft: "auto",
    transform: "translate(0%)",
    borderRadius: "50%",
    boxShadow: "0px 0px 18px 3px rgba(0,0,0,0.3)",
  },
  profileName: {
    fontSize: 15,
    fontFamily: PROFILE_STYLE.profileFont,
    color: "white",
    textAlign: "center",
    transform: "translate(0%)",
  },
  profileMessage: {
    width: "80%",
    margin: "auto",
    marginBottom: 15,
    fontSize: 12,
    fontFamily: PROFILE_STYLE.profileFont,
    padding: 9,
    textAlign: "left",
    transform: "translate(0%)",
    borderRadius: 9,
    backgroundColor: "rgba(255, 255, 255, 0.6)",
  },
};

export default profileStyles;
